var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 385 385"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M372.9 264.7c-6.6 0-12 5.4-12 12v84.2H24.1v-84.2c0-6.6-5.4-12-12-12s-12 5.4-12 12v96.2c0 6.6 5.4 12 12 12H373c6.6 0 12-5.4 12-12v-96.2c0-6.6-5.4-12-12.1-12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M183.7 285.2c4.7 4.6 12.5 4.7 17.2 0l84.2-83c4.8-4.7 4.7-12.3 0-17s-12.4-4.7-17.2 0l-63.5 62.6V12c0-6.6-5.4-12-12.2-12S180 5.4 180 12v235.7l-63.5-62.6c-4.8-4.7-12.4-4.7-17.2 0s-4.8 12.3 0 17z"
  })));
};
export default SvgDownload;